<template>
  <v-overlay  
    :value="!hadData" 
    :opacity="0"
  >
    <v-progress-circular 
      :size="size"
      :width="5"
      :value="50"
      :rotate="100"
      color="light-blue"
      indeterminate
    />
  </v-overlay>
</template>
<script>
export default {
  props : {
    hadData: {
      type : Boolean,
      default : false
    },
    size : {
      type : [String,Number],
      default : 100
    }
  }
}
</script>